import { useState } from "react";

export default function SiteFooter() {
  const [year] = useState(new Date().getFullYear());
  const cols = [
    {
      title: "栏目导航",
      links: [
        { label: "最新热瓜", href: "#hot" },
        { label: "反转时间线", href: "#reverse" },
        { label: "热榜追踪", href: "#rank" },
        { label: "辟谣专区", href: "#deny" },
      ],
    },
    {
      title: "快捷入口",
      links: [
        { label: "关于我们", href: "#about" },
        { label: "常见问题", href: "#faq" },
        { label: "订阅追更", href: "#subscribe" },
        { label: "联系我们", href: "mailto:hello@bage-chigua.cn" },
      ],
    },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-eye-2-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                扒哥<span className="text-primary-600">吃瓜</span>前线
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              专注热点事件的辟谣、反转、当事人回应与新瓜追踪，信息分层、多源交叉，帮你在围观中保持清醒。
            </p>
            <div className="mt-4 flex items-center gap-2">
              <a
                href="mailto:hello@bage-chigua.cn"
                aria-label="邮箱"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-mail-line"></i>
              </a>
              <a
                href="mailto:hello@bage-chigua.cn"
                aria-label="留言反馈"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-message-3-line"></i>
              </a>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">{c.title}</h4>
              <ul className="mt-3 flex flex-col gap-2">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      <i className="ri-arrow-right-s-line"></i>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {year} 扒哥吃瓜前线 · 内容基于公开信源整理，事实与观点分离呈现
          </p>
          <p className="text-xs text-foreground-500">
            <a href="mailto:hello@bage-chigua.cn" className="hover:text-primary-600">
              合作与投稿：hello@bage-chigua.cn
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}